import { gql } from "apollo-angular";

export const GETALL_TEST_SPECIFICATIONS_QUERY = gql`query configuratorAllTestSpecifications($Company: String, $RegBy: String, $OrgGroup: String) {
    configuratorAllTestSpecifications(Company: $Company, RegBy: $RegBy, OrgGroup: $OrgGroup) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
        Approval {
            Id
            Status
            ItemVersion
        }
    }
  }
  `
  
export const GET_TEST_SPECIFICATION_QUERY = gql`query configuratorTestSpecificationById($Uid: String!) {
    configuratorTestSpecificationById(Uid: $Uid) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const GET_TEST_SPECIFICATION_UI_TEMPLATE_QUERY = gql`query configuratorTestSpecificationUiTemplate {
    configuratorTestSpecificationUiTemplate {
        Name
        Category
        DefaultValue
        FieldType
        IsMultiValue
        HasHierarchyValues
        IsReadOnly
        Label
        IsRequired
        Order
        Tooltip
        ValueList
    }
  }
  `
export const GET_TEST_SPECIFICATION_SEARCH_UI_TEMPLATE_QUERY = gql`query configuratorTestSpecificationSearchUiTemplate {
    configuratorTestSpecificationSearchUiTemplate {
        Name
        Label
        Category
        DefaultValue
        Order
        FieldType
        Tooltip
        IsReadOnly
        IsRequired
        IsMultiValue
        HasHierarchyValues
        ValueList
    }
  }
  `

export const SEARCH_TEST_SPECIFICATION_QUERY = gql`query configuratorSearchTestSpecification($TestSpecification: TestSpecificationInput) {
  configuratorSearchTestSpecification(TestSpecification: $TestSpecification) {
        Version
        Uid
        ItemNo
        Name
        ModifiedBy
        ModificationTime
        LockedTime
        LockedBy
        CreationTime
        CreatedBy
        Comment
        ApprovedForTestLevel
        ApprovalStatus
    }
}
`